<button [style.color]="textColor" [style.background-color]="bgColor" [style.width]="width" mat-flat-button
    (click)="emitButtonClickEvent($event)" style="padding: 1rem">{{buttonText}}</button>